export enum PrintFooterLayoutType {
  None = 'None',
  AllPagesFixed = 'AllPagesFixed',
  AllPagesHugging = 'AllPagesHugging'
}
